import { render, staticRenderFns } from "./AsignarValorDistribuidor.vue?vue&type=template&id=807d6732"
import script from "./AsignarValorDistribuidor.vue?vue&type=script&lang=js"
export * from "./AsignarValorDistribuidor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports